"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function tryParse(json) {
    try {
        return JSON.parse(json);
    }
    catch (e) {
        return null;
    }
}
/**
 * Servicio para almacenar datos en los cookies o en el localstorage
 */
class CookieLocalStorageClass {
    /**
     * @param localstorage True para usar el localstorage, false para usar los cookies
     * @param serialize True para serializar el value
     */
    constructor(localstorage, serialize) {
        this.localstorage = localstorage;
        this.serialize = serialize;
    }
    /**Limpia todos los valores */
    Clear() {
        if (this.localstorage) {
            window.localStorage.clear();
        }
        else {
            document.cookie = "";
        }
    }
    /**Store a key-value pair */
    Set(name, value) {
        name = encodeURIComponent(name);
        if (this.localstorage) {
            window.localStorage.setItem(name, this.serialize ? JSON.stringify(value) : value);
        }
        else {
            var expireDays = 360;
            var d = new Date();
            d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            if (this.serialize) {
                value = encodeURIComponent(JSON.stringify(value));
            }
            document.cookie = name + "=" + value + "; " + expires;
        }
    }
    /**Get a value by its key. Returns null if the value is not found */
    Get(name) {
        name = encodeURIComponent(name);
        if (this.localstorage) {
            const r = window.localStorage.getItem(name);
            return r && (this.serialize ? tryParse(r) : r);
        }
        else {
            var name = name + "=";
            var ca = document.cookie.split(';');
            var value = null;
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    value = c.substring(name.length, c.length);
                }
            }
            if (!value)
                return null;
            if (this.serialize) {
                return tryParse(decodeURIComponent(value));
            }
        }
        return null;
    }
    /**Remove a value by its key */
    Remove(name) {
        if (this.localstorage) {
            window.localStorage.removeItem(name);
        }
        else {
            var d = new Date();
            d.setTime(d.getTime() + (-1 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + "" + "; " + expires;
        }
    }
}
exports.CookieLocalStorageClass = CookieLocalStorageClass;
/**Servicio de cookies por default */
exports.cookies = new CookieLocalStorageClass(window.localStorage != null, true);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/cookies.js
// module id = 499
// module chunks = 0